import React from "react";
import Right from "../accueil/right/right";

const Forum = () => {
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          color: "orange",
          justifyContent: "center",
        }}
      >
        En cour de développement...
      </div>
      <Right />
    </div>
  );
};

export default Forum;
